__turbopack_context__.v({
  "animate": "cBuq3G_animate",
  "backgroundWrapper": "cBuq3G_backgroundWrapper",
  "copyBox": "cBuq3G_copyBox",
  "flame": "cBuq3G_flame",
  "flameBox": "cBuq3G_flameBox",
  "foregroundImage": "cBuq3G_foregroundImage",
  "foregroundWrapper": "cBuq3G_foregroundWrapper",
  "frameBoxWrapper": "cBuq3G_frameBoxWrapper",
  "inner": "cBuq3G_inner",
  "root": "cBuq3G_root",
});
